// extracted by mini-css-extract-plugin
export default {"section":"SectionMain_section__6YS31","video":"SectionMain_video__ZLPII","overlayContent":"SectionMain_overlayContent__V-rF7"};